import "../../challenges/Challenges.css"
import React, { useState,useEffect } from "react";
import "../../myProjects/Myprojects.css"
import { FileUploader } from 'react-drag-drop-files';
import api from "views/auth/Api";
import { message } from 'antd';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FaRegWindowClose } from "react-icons/fa";
import { Link } from "react-router-dom";




const EditQuizTraining = () => {
  const [quiz , setQuiz] = useState([]); 
  const [formInputs , setFormInputs] = useState({
          questionText:"",
          options:[],
          correctAnswer:"",
          points:""
        });
  const [delOpen , setDelOpen] = useState(false)
const [delOneId , setDelOneId] = useState(null)
//   const [editId, setEditId] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

 const successAddQuiz = () => {
    message.success('Your quiz added successfully');
          };
const successSaved = () => {
           message.success('Your quiz Edited Completely');
          };
          
  const delSuccess = ()=>{
    message.success('Delete done');
  }

     useEffect(() => {
     api.get(`${API_BASE_URL}mcq-training/all/${id}`)
      .then((response) => {  
        if (!response.data) {
          navigate(`/auth/not-found/`);
        }
    setQuiz(response.data)
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [navigate,id]);


const isFormValid = formInputs.questionText.trim() !== '' && formInputs.options.length > 0
&& formInputs.correctAnswer.trim() !== '' && formInputs.points.trim() !== '';

    const handleAddQuiz = (event) => {
    event.preventDefault();
      addQuiz();
        setFormInputs({
          questionText:"",
          options:[],
          correctAnswer:"",
          points:"",
        })

    }
  

      const addQuiz = async () => {  
       await api.post(`${API_BASE_URL}mcq-training/add-question`,{
          questionText: formInputs.questionText,
          options: formInputs.options,
          correctAnswer: formInputs.correctAnswer,
          points: formInputs.points,
          training: id,
          })
        .then(function (response) {
                  console.log("handlesubmitffff  ", response.data)
                  successAddQuiz()
                  setQuiz(response.data);
              // setData(response.data)
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
        });   
          }

 const confirmDel = async (id)=>{
    if (id) {
      setDelOpen(false)
     await api.delete(`${API_BASE_URL}mcq-training/${id}`)
      .then(function (response) {
          setQuiz(response.data);
          delSuccess();
      }).catch(error => {
        console.log("handlesubmit error for blog ", error)
      });
  }
 }

const delId =(quiz)=>{
  setDelOpen(true)
  setDelOneId(quiz)
 }


  return (
    <div className="h-fit w-full pt-10"> 
    <h2 className="addLibrary-h2">Edit Project Quiz</h2> 
         {quiz ? 
                <div className="model3d-cards-add flex-wrap" >
                   {quiz.map(quiz =>
        <div className="card-container resCardDel"  onClick={()=> {delId(quiz)}}>
        <h2 className="h2CardRes">{quiz.questionText}</h2>
            </div>   )}
                </div> 
          : null}

   <form className="addChallenge mb-[100px]"> 
      <div className="addChallengeFlex mt-6">
         <div className="addChallengeLR">
    <div className="addCHInpts">
            <label for="questionText">Question</label>
            <input type="text" className="inputWidth" id="questionText" value={formInputs.questionText} placeholder="Enter question text" 
            onChange={(e) =>setFormInputs({...formInputs, questionText: e.target.value})}/>
          </div>
<div className="addCHInpts">
            <label for="options">Choices</label>
            <textarea type="text" className="inputWidth" id="options" value={formInputs.options} placeholder="Enter Options"
             onChange={(e) =>setFormInputs({...formInputs, options: e.target.value})}/>
           </div>

    </div>
        <div className="addChallengeLR">
    <div className="addCHInpts">
            <label for="correctAnswer">Correct Answer</label>
            <input type="text" className="inputWidth" id="correctAnswer" value={formInputs.correctAnswer} placeholder="Enter Correct Answer"
             onChange={(e) =>setFormInputs({...formInputs, correctAnswer: e.target.value})}/>
           </div> 
    <div className="addCHInpts">
            <label for="points">Points</label>
            <input type="number" className="inputWidth" id="points" value={formInputs.points} placeholder="Enter Points"
             onChange={(e) =>setFormInputs({...formInputs, points: e.target.value})}/>
           </div> 

          </div>        
</div>

        <div className="flex justify-center gap-x-4 mt-[25px]">
       <button onClick={handleAddQuiz} disabled={!isFormValid} className="add-plate w-[100px]">Add </button>
      <Link to={`/admin/training/voxel/${id}`}> <button onClick={successSaved} className="add-plate w-[100px]">Save</button> </Link>
        </div>
       </form> 
               { delOpen ? <div className="modal"> <div id="delPopup">
                   <button id="popIcon" onClick={()=>{setDelOpen(false)}}>
                   <FaRegWindowClose className="w-full h-full	"/>
                 </button>
                 <div id="helpText"><span >Do you want to delete this one?</span>
                  <p className="delResName">( {delOneId.questionText} )</p>
                  </div>
                 <div className="resYesNo">
                 <button className="yesorno" onClick={()=>{setDelOpen(false)}}> No </button> 
                 <button className="yesorno" onClick={() => {confirmDel(delOneId.id)}}> Yes </button>  </div>
                   </div></div> : null}
    </div>
  );
};

export default EditQuizTraining;
